<template>
  <div class="contact-container">
    <div class="contact-list">
      <div class="contact-line" v-for="(contact, key) in getContact" :key="'contact_'+key">
        <div class="contact-line-inner" v-if="contact.TSUP === 'N'">
          <div class="form-field">
            <label>{{$_('last_name')}} *</label>
            <Input
              :type="'text'"
              class="contact-name"
              :val="contact.TNOM"
              :required="true"
              :ref="'tnom'"
              :maxlength="25"
              @typing="vSetStoreContact('TNOM', key, $event.toUpperCase())"
            />
          </div>
          <div class="form-field">
            <label>{{$_('first_name')}}</label>
            <Input
              :type="'text'"
              class="contact-name"
              :val="contact.TPNOM"
              :maxlength="25"
              @typing="vSetStoreContact('TPNOM', key, $event.toUpperCase())"
            />
          </div>
          <div class="form-field">
            <label>{{$_('email')}} *</label>
            <Input
              :type="'email'"
              class="contact-email"
              :val="contact.TMAIL"
              :required="true"
              :ref="'tmail'"
              :maxlength="40"
              @typing="vSetStoreContact('TMAIL', key, $event.toUpperCase())"
            />
          </div>
          <div class="form-field">
            <label>{{$_('tel')}}</label>
            <Input
              :type="'tel'"
              :val="contact.TTEL"
              :maxlength="30"
              @typing="vSetStoreContact('TTEL', key, $event.toUpperCase())"
            />
          </div>
          <div class="form-field">
            <label>{{$_('position')}}</label>
            <Select
              :placeholder="$_('your_choice')"
              :itemoption="['TFCTC', 'TLIB_FCT']"
              :data="capacity"
              :preselected="contact.TFCTC"
              @select-change="vSetStoreContact('TFCTC', key, $event.item)"
            />
          </div>
          <div class="form-field display-flex line-align-top">
            <input
              type="radio"
              class="radio"
              :id="'sample_contact_'+key"
              name="sSampleContact"
              @change="vSampleContact(key)"
              :checked="contact.TENV === 'O'"
            />
            <label :for="'sample_contact_'+key">{{$_('sample_contact')}}</label>
          </div>
          <div class="form-field display-flex align-items-center line-align-top">
            <span class="trash-line" v-if="contact.TENV === 'N'" @click="vDeleteLine(key)">
              <img src="@/modules/produit/assets/img/trash.png" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-add-list">
      <span @click="vAddContact">+ {{$_('add_contact')}}</span>
    </div>
  </div>
</template>

<script>
import Input from "@/common/components/widget/Input/Input";
import Select from "@/common/components/widget/Select";

import customerService from "@/modules/client/services/customerService";

export default {
  name: "ContactList",
  components: {
    Input,
    Select
  },
  data() {
    return {
      capacity: Array(),
      bSampleContact: false
    };
  },
  created() {
    customerService.getFonction().then(res => {
      this.capacity = res.data.DS_O.OUT;
    });

    if (this.getContact.length === 0) {
      this.vAddContact(true);
    }
  },
  computed: {
    getContact() {
      return this.$store.getters["echantillon/get_contact"];
    },
    getCustomer() {
      return this.$store.getters["echantillon/get_tncli"];
    }
  },
  watch: {
    getCustomer(val) {
      if (val !== 0) {
        this.vSearchContact();
      }
    }
  },
  methods: {
    vDeleteLine(key) {
      this.vSetStoreContact("TSUP", key, "O");
    },
    vAddContact(bFirstContact) {
      this.$store.dispatch("echantillon/SET_CONTACT", {
        TFCTC: "",
        TNOM: "",
        TPNOM: "",
        TTEL: "",
        TMAIL: "",
        TLIG: 0,
        TSUP: "N",
        TENV: bFirstContact === true ? "O" : "N"
      });
    },
    vSampleContact(key) {
      let arr = Array();

      this.getContact.map((contact, index) => {
        if (index === key) {
          contact.TENV = "O";
        } else {
          contact.TENV = "N";
        }

        arr.push(contact);
      });

      this.$store.dispatch("echantillon/SET", {
        key: "form_contact",
        value: arr
      });
    },
    vSetStoreContact(key, line, value) {
      this.$store.dispatch("echantillon/SET_CONTACT_LINE", {
        key,
        line,
        value
      });
    },
    vSearchContact() {
      customerService
        .getContact(this.$store.getters["echantillon/get_tncli"])
        .then(res => {
          let contact_array = Array();

          res.data.DS_O.OUT.map(contact => {
            contact.TSUP = "N";

            if (contact.TENV === "O") {
              this.bSampleContact = true;
            } else {
              contact.TENV = "N";
            }
            contact_array.push(contact);
          });

          if (contact_array.length > 0 && this.bSampleContact === false) {
            contact_array[0].TENV = "O";
            this.$store.dispatch("echantillon/SET", {
              key: "form_contact",
              value: contact_array
            });
          } else {
            this.$store.dispatch("echantillon/SET", {
              key: "form_contact",
              value: []
            });
            this.vAddContact(true)
          }
    
        });
    }
  }
};
</script>

<style scoped>
.contact-list {
  background-color: #f5f5f5;
  margin-top: 30px;
  padding: 20px;
}
.contact-line-inner {
  display: flex;
  align-items: center;
}
.contact-line .form-field {
  margin: 0px 10px;
}
/deep/ .contact-line .form-field input {
  min-width: 110px;
  max-width: 170px;
}
.contact-line > div {
  display: flex;
}
input.contact-email {
  width: 250px;
}
input.contact-name,
input.contact-first-name {
  width: 140px;
}
.trash-line {
  border: solid 1px #61424d;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.trash-line:hover {
  cursor: pointer;
}
.trash-line img {
  width: 20px;
}
@media screen and (max-width: 800px) {
  .contact-line-inner {
    flex-direction: column;
  }
  /deep/
  .contact-line .input-text-container .form-field input {
    max-width: 100%;
  }
  /deep/
  .contact-line-inner .form-field input {
    width: 100%;
    min-width: 100%;
  }
  .contact-list {
    margin: 0px;
  }
}
</style>